import qs from 'qs';
import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Video from './views/Video.vue';
import Layers from './views/Layers.vue';
import Parser from './views/Parser.vue';
import Slope from './views/Slope.vue';
import Api from './views/Api.vue';

import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/videos/:id',
      name: 'video',
      component: Video,
    },
    {
      path: '/layers',
      name: 'layers',
      component: Layers,
    },
    {
      path: '/parser',
      name: 'parser',
      component: Parser,
    },

    {
      path: '/slope',
      name: 'slope',
      component: Slope,
      meta: {
        hideNav: true,
      },
    },
    {
      path: '/api',
      name: 'api',
      component: Api,
      meta: {
        hideNav: true,
      },
    },
  ],
  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    const result = qs.stringify(query);

    return result ? '?' + result : '';
  },
});
